import { Alert, Box, Button, Paper, Snackbar, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Utils from "../utils/Utils";

const { serverURL } = Utils;

export default function Help() {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim()) return;

    try {
      setIsSubmitting(true);

      const response = await fetch(`${serverURL}/help`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ message }),
      });

      if (!response.ok) {
        throw new Error(await response.text());
      }

      setMessage("");
      setSnackbar({ open: true, message: t("helpMessageSent"), severity: "success" });
    } catch (error) {
      setSnackbar({ open: true, message: error.message || t("helpMessageError"), severity: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box className="w-full" alignSelf="center">
      <Paper
        className="max-w-[600px] w-full mx-auto"
        elevation={3}
        sx={{
          padding: "2rem 1rem",
          my: 2,
          borderRadius: 3,
        }}
      >
        <Box textAlign="center" marginBottom="1rem">
          <img src="logo.png" alt="Logo" />
        </Box>
        <Typography variant="h4" my={3} textAlign="center">
          {t("getHelp")}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            id="outlined-textarea"
            label={t("yourMessage")}
            placeholder={t("whatCouldWeImprove")}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            fullWidth
          />
          <Box sx={{ display: "flex" }}>
            <Button
              disabled={message.trimStart().length === 0 || isSubmitting}
              sx={{
                margin: "1rem auto",
                padding: "0.5rem 1.5rem",
                borderRadius: "100px",
                textTransform: "none",
              }}
              variant="contained"
              color="success"
              type="submit"
            >
              {isSubmitting ? "Sending..." : t("submit")}
            </Button>
          </Box>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
